import React from 'react';

const Chapter5Content = () => {
  return (
    <article className="prose prose-lg max-w-none">
      <div className="text-center mb-12">
        <h1 className="text-4xl font-bold text-gray-900 mb-2">Chapter Five</h1>
        <p className="text-xl text-gray-600">The Four Witnesses</p>
        <p className="text-lg text-gray-500 mt-2">The Simplest Summary of All</p>
      </div>

      <div className="mb-12">
        <p className="text-gray-800 leading-relaxed mb-4">
          The Bible says a matter is established by two or three witnesses. We have four. And they agree perfectly.
        </p>
      </div>

      {/* First Witness */}
      <div className="mb-12">
        <div className="bg-blue-50 border-l-4 border-blue-600 p-6 mb-6">
          <h2 className="text-2xl font-bold text-blue-900 mb-2">The First Witness: John</h2>
        </div>
        <p className="text-gray-800 leading-relaxed mb-4">
          John is on Patmos. He has been shown the end of all things. He watches tribulation martyrs rise to reign with Christ. And he records five words:
        </p>
        <p className="text-xl font-bold text-center text-gray-900 my-6">
          "This is the first resurrection."
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          If the first resurrection comes after the tribulation — and the people in it are people who died in the tribulation — then no resurrection of the righteous came before it.
        </p>
        <p className="text-gray-800 leading-relaxed font-semibold">
          John testifies: the gathering is after the tribulation. After the 6th seal, trumpet and bowl. At the 7th seal, last trumpet and bowl.
        </p>
      </div>

      {/* Second Witness */}
      <div className="mb-12">
        <div className="bg-green-50 border-l-4 border-green-600 p-6 mb-6">
          <h2 className="text-2xl font-bold text-green-900 mb-2">The Second Witness: Paul</h2>
        </div>
        <p className="text-gray-800 leading-relaxed mb-4">
          Paul is writing to Corinth, speaking about the transformation of both the living and the dead. He anchors it to a specific moment:
        </p>
        <p className="text-xl font-bold text-center text-gray-900 my-6">
          "At the last trumpet... the dead shall be raised."
        </p>
        <p className="text-gray-800 leading-relaxed mb-4">
          The last trumpet of 1 Corinthians 15 is defined by scripture as the seventh trumpet of Revelation — the one at the end of all things.
        </p>
        <p className="text-gray-800 leading-relaxed font-semibold">
          Paul testifies: the gathering is at the last trumpet — at the end when death is destroyed.
        </p>
      </div>

      {/* Third Witness */}
      <div className="mb-12">
        <div className="bg-purple-50 border-l-4 border-purple-600 p-6 mb-6">
          <h2 className="text-2xl font-bold text-purple-900 mb-2">The Third Witness: Jesus</h2>
        </div>
        <p className="text-gray-800 leading-relaxed mb-4">
          Jesus is sitting with His disciples on the Mount of Olives. They have asked Him when He is coming back. He gives them an answer with the most precise timing word:
        </p>
        <p className="text-xl font-bold text-center text-gray-900 my-6">
          "Immediately after the tribulation... they shall gather together His elect with a great trumpet."
        </p>
        <p className="text-gray-800 leading-relaxed font-semibold">
          Jesus testifies: the gathering is immediately after — not before, not during. After. At the great trumpet.
        </p>
      </div>

      {/* Fourth Witness */}
      <div className="mb-12">
        <div className="bg-amber-50 border-l-4 border-amber-600 p-6 mb-6">
          <h2 className="text-2xl font-bold text-amber-900 mb-2">The Fourth Witness: Paul Again</h2>
        </div>
        <p className="text-gray-800 leading-relaxed mb-4">
          Paul is correcting a misunderstanding of when the Rapture occurs:
        </p>
        <p className="text-xl font-bold text-center text-gray-900 my-6">
          "After the rebellion and reign of Antichrist then the Rapture."
        </p>
        <p className="text-gray-800 leading-relaxed font-semibold">
          Paul testifies: the gathering is after — not before. After the Antichrist rules.
        </p>
      </div>

      {/* Summary */}
      <div className="bg-gradient-to-r from-amber-50 to-orange-50 border-2 border-amber-300 rounded-lg p-8 my-12">
        <h2 className="text-2xl font-bold text-center text-gray-900 mb-6">When Four Witnesses Agree</h2>
        <p className="text-gray-800 leading-relaxed mb-4">
          Four witnesses. Four different authors. Four different books. Written across decades, across genres, across generations. And they speak in perfect unison:
        </p>
        <div className="space-y-3 my-6">
          <p className="text-gray-900"><strong>John:</strong> The first resurrection is after the tribulation. At the 7th trump</p>
          <p className="text-gray-900"><strong>Paul:</strong> The resurrection is at the last trumpet — at the end.</p>
          <p className="text-gray-900"><strong>Jesus:</strong> The gathering is immediately after the tribulation. At the Great trump</p>
          <p className="text-gray-900"><strong>Paul:</strong> The gathering is after the reign of Antichrist.</p>
        </div>
        <p className="text-xl font-bold text-center text-amber-900 mt-8">
          In the law, two or three witnesses establish a matter. The matter is established. The case is closed.
        </p>
      </div>

      <div className="flex justify-center gap-4 my-8">
        <span className="text-2xl text-amber-600">✦</span>
        <span className="text-2xl text-amber-600">✦</span>
        <span className="text-2xl text-amber-600">✦</span>
      </div>
    </article>
  );
};

export default Chapter5Content;